import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const getLoyaltyPointsEarnedFromOrder = {
  name: "getLoyaltyPointsEarnedFromOrder" as const,
  input: z.object({ customerId: zExt.objectId(), orderId: zExt.objectId() }),
  output: z.object({ loyaltyPointsEarned: z.number() }),
};
